import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

 
 
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
  Legend
);

const RenewalStatusReport = () => {
  const [activeFilter, setActiveFilter] = useState("Monthly");

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Renewed",
        data: [68, 75, 50, 28, 42, 90, 73, 65, 78, 40, 25, 80],
        backgroundColor: "#1cb4b4",
        borderRadius: 10,
        barThickness: 20, // Controls bar width
        maxBarThickness: 20,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          color: "#333",
          padding: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax: 90,
        ticks: {
          autoSkip: false,
          stepSize: 10,
          precision: 0,
          color: "#666",
          callback: function (value) {
            return value.toString().padStart(2, "0");
          },
        },
        grid: {
          color: "#eee",
          drawBorder: false,
        },
      },
      x: {
        ticks: {
          color: "#666",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const filters = ["Daily", "Weekly", "Monthly"];


const RenewalData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Audit Surveillance",
        data: [48, 60, 47, 62, 69, 45, 59, 85, 49, 60, 47, 61],
        fill: true,
        backgroundColor: "rgba(0, 192, 230, 0.1)",
        borderColor: "#00c0e6",
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#00c0e6",
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const RenewalOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false, // ✅ This hides the default legend
      },
      tooltip: {
        callbacks: {
          label: (context) => `Audit Surveillance : ${context.formattedValue}`,
          title: (context) => context[0].label,
        },
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#00a8cc",
        borderColor: "#00a8cc",
        borderWidth: 1,
        titleFont: { weight: "bold" },
        padding: 10,
        displayColors: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 90,
        ticks: {
          stepSize: 10,
          callback: (val) => val.toString().padStart(2, "0"),
        },
        grid: {
          drawTicks: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  

  return (
    <div className="renewable-status">
      <div className="renewable-cards">
        <div className="renewable-card mt-2">
          <h4>Total Expired Certifications</h4>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <h3>7,265</h3>
            <h6>-0.03%</h6>
          </div>
        </div>

        <div className="renewable-card mt-2">
          <h4>Renewed Certifications</h4>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <h3>7,265</h3>
            <h6>+11.01%</h6>
          </div>
        </div>

        <div className="renewable-card mt-2">
          <h4>Renewal Rate</h4>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <h3>75</h3>
            <h6>%</h6>
          </div>
        </div>

        <div className="renewable-card mt-2">
          <h4>Average Renewal Time</h4>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <h3>30</h3>
            <h6>Days</h6>
          </div>
        </div>
      </div>

      <div className="chart-container mt-4">
        <div className="chart-header">
          <div className="chart-title">Renewal Count</div>
          <div className="chart-filters">
            {filters.map((filter) => (
              <button
                key={filter}
                className={`filter-button ${
                  activeFilter === filter ? "active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
        <div className="bar-chart-wrapper">
          <Bar data={data} options={options} />
        </div>
      </div>

        <div className="chart-container mt-5">
               <div className="header">
                 <div>
                   <h2>Renewal Rate Trend</h2>
                   <span
                     className="sub-label"
                     style={{ fontSize: "14px", color: "grey" }}
                   >
                     <span style={{ color: "#3BBDC4", fontSize: "16px" }}>●</span>{" "}
                     Renewal Rate
                   </span>
                 </div>
                 <div className="toggle-buttons">
                   <button>Daily</button>
                   <button>Weekly</button>
                   <button className="active">Monthly</button>
                 </div>
               </div>
               <div className="chart-wrapper">
                 <Line data={RenewalData} options={RenewalOptions} />
               </div>
             </div>
       

    </div>
  );
};

export default RenewalStatusReport;
